import { render, staticRenderFns } from "./Saturation.vue?vue&type=template&id=bc1ba892"
import script from "./Saturation.vue?vue&type=script&lang=js"
export * from "./Saturation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports